import { MyFavouritesMatchButton } from '@/features/my-favourites/components/my-favourites-match-button'
import { Button } from '@nf/ui'
import { newbieMatchStyle } from '../newbie-match.style'
import { SportMatchModel } from '@nf/types/odds'
import { useRouter } from '@/navigation'
import { MatchTimer } from '@/features/sportsbook-aside/components/match-item/match-timer'
import { sportsbookService } from '@/services/sportsbook.service'
import { useCurrentProperties } from '@/hooks/query'
import { Breakpoint } from '@/features/breakpoint'
import { useBreakpoint } from '@/features/breakpoint/contexts'
import { setKafkaNormal } from '@/hooks/query/use-kafka-log'
import { useAppearanceStore } from '@/store/appearance'
import { ViewEnum } from '@/types'
import { KafkaNote } from '@nf/utils-common/constants'
import { AnalyseKey, useConfigsAnalyseAttribute } from '@/features/next-analyse'
import { useGoldenDuelSetting } from '@/hooks/query/golden-duel'

interface NewbieMatchInfoProps {
	match: SportMatchModel;
	betTypeCount: number;
}
export const NewbieMatchInfo = ({
	match,
	betTypeCount,
}: NewbieMatchInfoProps) => {
	const {
		GameID,
		MaT,
		LeagueId,
		MatchId
	} = match;
	const router = useRouter();
	const view = useAppearanceStore(state => state.view);
	const { getRef } = useConfigsAnalyseAttribute([{ key: 'switch-to-single-match-via-num-btn', analyseKey: AnalyseKey.Refined }]);
	const { breakpoint } = useBreakpoint();
	const { eventMode, eventName } = useCurrentProperties();
	const { isGoldenDuelSupported } = useGoldenDuelSetting();

	const setKafka = () => {
		if (view == ViewEnum.mars && breakpoint <= Breakpoint.sm) {
			setKafkaNormal({
				note: KafkaNote.MarsV1,
				type: 6,
				action: 34
			});
		}
	}

	const setPromotionKafka = () => {
		if (isGoldenDuelSupported(GameID, LeagueId)) {
			setKafkaNormal({
				note: KafkaNote.GoldenDuel,
				type: 1,
				action: 45
			});
		}
	}

	const handleVisitSingleMatch = () => {
		setKafka();
		setPromotionKafka();
		const singleMatchHref = sportsbookService.makeSingleMatchPath({
			gameId: GameID,
			maT: MaT,
			leagueId: LeagueId,
			matchId: MatchId,
			eventMode: eventMode,
			eventName: eventName
		});
		router.push(singleMatchHref);
	}

	return (
		<div className={newbieMatchStyle.info}>
			<div className={newbieMatchStyle.timer}>
				<MyFavouritesMatchButton matchId={match.MatchId} time={match.Ktm || match.Etm} sportType={match.GameID} />
				<div className={newbieMatchStyle.time}>
					<div className="match-timer">
						<MatchTimer match={match} />
					</div>
				</div>
			</div>
			<Button
				variant="icon"
				ref={getRef('switch-to-single-match-via-num-btn')}
				className={newbieMatchStyle.moreButton}
				onClick={handleVisitSingleMatch}
			>
				{(betTypeCount) > 99 ? '99+' : `${(betTypeCount)}+`}
			</Button>
		</div>
	)
}